// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"137b251e","455":"a9ea1dd1"}[chunkId] + ".chunk.js";
};